export default {
  patients: {
    label: 'Pazienti',
    patientsList: 'Lista Pazienti',
    viewPatients: 'Vedi Pazienti',
    viewPatient: 'Vedi Paziente',
    newPatient: 'Nuovo Paziente',
    successfullyCreated: 'Paziente creato con successo',
    successfullyAddedNote: 'Note aggiunte con successo',
    successfullyAddedRelatedPerson: 'Relazione di parentela aggiunta con successo',
  },
}
